import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { phonesActionTypes } from '../reducer';

function* fetchPhones() {
  yield requestSaga({
    actionType: phonesActionTypes.getList,
    request: dataProvider.getList,
    resource: resources.phone.list,
  });
}

export default fetchPhones;
